export default "__VITE_ASSET__4d54ab01__"